<template>
    <BaseDialog v-model:open="open" :title="title" title-style="serif" width="narrow" @close="onCancel">
        <p v-if="text" class="body text-ink-muted">{{ text }}</p>
        <slot></slot>
        <template #footer>
            <BaseButton theme="tertiary" data-testid="cancel-button" @click="onCancel">{{ cancelLabel }}</BaseButton>
            <BaseButton theme="primary" :disabled="confirmDisabled" data-testid="confirm-button" @click="onConfirm">
                {{ confirmLabel }}
            </BaseButton>
        </template>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";

interface Props {
    title: string;
    text?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmDisabled?: boolean;
}

withDefaults(defineProps<Props>(), {
    text: "",
    confirmLabel: "Submit responses",
    cancelLabel: "Continue editing",
    confirmDisabled: false,
});

const emit = defineEmits<{ confirm: []; cancel: [] }>();

const open = defineModel<boolean>("open", { default: false });

function onConfirm() {
    emit("confirm");
}

function onCancel() {
    open.value = false;
    emit("cancel");
}
</script>
